import { useState } from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { AvatarWithCircle } from "../../user-menu-trigger/user-avatar/avatar-with-circle";
import { Box, Typography } from "@mui/material";

interface UsersTableProps {
  selectedLogins: string[];
  setSelectedLogins: (value: string[]) => void;
  users: any;
}

function reorderFields(fields: string[], preferredOrder: string[]) {
  const presentPreferred = preferredOrder.filter((field) =>
    fields.includes(field)
  );
  const rest = fields.filter((field) => !preferredOrder.includes(field));

  return [...presentPreferred, ...rest];
}

export const UsersTable = ({
  selectedLogins,
  setSelectedLogins,
  users,
}: UsersTableProps) => {
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  if (!users || users.length === 0) {
    return (
      <Typography
        variant="h6"
        sx={{
          mt: "1.5rem",
          textAlign: "center",
        }}
      >
        There are now users signed up
      </Typography>
    );
  }

  const fields = reorderFields(Object.keys(users[0]), [
    "avatar",
    "user_id",
    "user_name",
    "login",
    "email",
    "role",
    "country",
    "city",
    "line",
  ]);

  const columns: GridColDef[] = fields.map((field) => {
    if (field === "avatar") {
      return {
        field: "avatar",
        headerName: "Avatar",
        width: 100,
        renderCell: ({ value, row }) => (
          <div className="w-full h-full flex items-center justify-center">
            <AvatarWithCircle
              img={value || undefined}
              size="40px"
              name={row.name}
              userId={String(row.user_id)}
            />
          </div>
        ),
        sortable: false,
        filterable: false,
      };
    }

    if (field === "user_name") {
      return { field: "user_name", headerName: "Name", width: 150 };
    }

    return {
      field,
      headerName: field.charAt(0).toUpperCase() + field.slice(1),
      width: 150,
    };
  });

  return (
    <Box sx={{ height: "100%", width: "100%" }}>
      <DataGrid
        rows={users}
        columns={columns}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        pageSizeOptions={[10, { value: -1, label: "All" }]}
        pagination
        disableRowSelectionOnClick
        checkboxSelection
        rowSelectionModel={selectedLogins}
        onRowSelectionModelChange={(newSelection) =>
          setSelectedLogins(newSelection as string[])
        }
        getRowId={(user) => user.login}
        sx={{
          width: "100%",
          height: "100%",
          WebkitOverflowScrolling: "touch",
        }}
      />
    </Box>
  );
};
